import { useEffect, useState } from 'react';
import teamsApi from 'api/requests/teams';

let catalogRequest = null;

function loadCatalog() {
    if (!catalogRequest) {
        catalogRequest = teamsApi.permissionsCatalog()
            .then(({ data }) => data)
            .catch((error) => {
                catalogRequest = null;
                throw error;
            });
    }

    return catalogRequest;
}

/**
 * O catálogo de permissões do painel vindo da API (grupos, rótulos e o que
 * cada permissão já inclui). Uma busca só por carregamento da página.
 */
export default function useTeamPermissionCatalog() {
    const [catalog, setCatalog] = useState(null);

    useEffect(() => {
        let cancelled = false;

        loadCatalog()
            .then((data) => { if (!cancelled) setCatalog(data); })
            .catch(() => { /* a tela mostra o estado vazio */ });

        return () => { cancelled = true; };
    }, []);

    const labels = {};
    (catalog?.groups || []).forEach((group) => {
        group.permissions.forEach((permission) => { labels[permission.key] = permission.label; });
    });

    return {
        loading: !catalog,
        groups: catalog?.groups || [],
        implications: catalog?.implications || {},
        labelOf: (key) => labels[key] || key,
    };
}
